<template>
  <!-- 基本法 -->
  <div class="salesman-form-promotion" v-loading="loading" v-if="curTreeData">
    <div class="btn-wrap">
      <Button style="margin-right:10px;" type="primary" @click="$refs.addPromotion.open(formData)">添加基本法</Button>
      <Button ghost
        v-if="disabled && userInfo.orgType == 1 && curTreeData.status == 1 && formDataBak.baseMethodList && formDataBak.baseMethodList.length != 0"
        type="primary" @click="disabled = false; getParentData()">编辑</Button>
      <div v-else-if="!disabled">
        <Button type="primary" @click="save()">保存</Button>
        <Button ghost type="primary" @click="disabled = true; isGet = false; getFormData(id)">取消</Button>
      </div>
    </div>
    <Form ref="form" :model="formDataBak" :label-width="75" class="page-form" v-if="formDataBak.baseMethodList">
      <div class="promotion-item" v-for="(item, i) in formDataBak.baseMethodList" :key="i">
        <FormItem :prop="`baseMethodList.${i}.name`" :key="`baseMethodList.${i}.name`" label="基本法名称">
          <Input v-model="item.name" placeholder="请输入" :disabled="true" />
        </FormItem>
        <FormItem :prop="`baseMethodList.${i}.startTime`" :key="`baseMethodList.${i}.startTime`" label="开始时间">
          <DatePicker type="date" v-model="item.startTime" format="yyyy-MM-dd" placeholder="请选择" :options="dateOptions"
            :disabled="disabled || disabledDate(item.startTime)"></DatePicker>
        </FormItem>
        <FormItem :prop="`baseMethodList.${i}.endTime`" :key="`baseMethodList.${i}.endTime`" label="结束时间">
          <DatePicker type="date" v-model="item.endTime" format="yyyy-MM-dd" placeholder="请选择" :options="dateOptions"
            :disabled="disabled || disabledDate(item.endTime)"></DatePicker>
        </FormItem>
        <FormItem :prop="`baseMethodList.${i}.baseRanks`" :key="`baseMethodList.${i}.baseRanks`" label="基本法职级"
          class="full" v-if="item.baseRanks && item.baseRanks.length">
          <ul class="rankList">
            <li class="" v-for="(rank, i) in item.baseRanks" :key="i">{{ rank.name }}</li>
          </ul>
        </FormItem>
        <!-- <FormItem :prop="`baseMethodList.${i}.updateTime`" :key="`baseMethodList.${i}.updateTime`" label="更新时间">
          <DatePicker type="date" v-model="item.updateTime" format="yyyy-MM-dd" :disabled="true"></DatePicker>
        </FormItem> -->
      </div>
      <div class="empty-box" v-if="formDataBak.baseMethodList.length == 0">
        <img src="@static/images/empty.png" alt />
        <div class="text">请给此机构分配基本法,<span class="link" @click="$refs.addPromotion.open(formData)">点击</span>前往设置</div>
      </div>

    </Form>

    <!-- 新增基本法 -->
    <add-promotion ref="addPromotion" @success="getFormData(formData.id)"></add-promotion>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import addPromotion from './addPromotion'
export default {
  components: { addPromotion },
  props: {
    formData: null,
    curTreeData: null,
  },
  data() {
    return {
      id: "",
      promotionList: [],
      parentBaseMethodList: [],
      formDataBak: {},
      isGet: false,
      disabled: true,
      loading: false,
      showExtendBtn: false,
      dateOptions: {
        disabledDate: (date) => {
          return date && date.valueOf() < Date.now()
        },
      },
      userInfo: {},
    };
  },
  watch: {
    disabled: {
      handler() {
        this.$emit("isEdit", !this.disabled);
      },
      immediate: true,
    }
  },
  computed: {},
  created() { },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
    // this.queryByMechan();
  },
  methods: {
    linkToBase() {
      this.$router.push({
        path: '/basicLawNew/config',
        name: "basicLawNewConfig",
      })
    },
    setData(data) {
      this.disabled = true;
      this.formDataBak = { baseMethodList: [] }
      this.id = data.id;
      this.getFormData(data.id)
    },
    // 时间禁用判断
    disabledDate(date) {
      return dayjs().isAfter(dayjs(date))
    },
    // 获取父级基本法
    getParentData() {
      this.loading = true;
      this.$http({
        type: "GET",
        url: "/buz/baseMethod/queryByOrgId",
        data: {
          orgId: this.formData.parentId
        }
      }).then(res => {
        this.parentBaseMethodList = res.data;
        if (this.parentBaseMethodList.length && !this.formDataBak.baseMethodList.length) {
          this.showExtendBtn = true;
        } else {
          this.showExtendBtn = true;
        }
      }).finally(res => {
        this.loading = false;
      });
    },
    // 同步父级基本法
    // setParentData() {
    //   if (this.isGet) {
    //     this.$set(this.formDataBak, "baseMethodList", [].concat(this.parentBaseMethodList));
    //   } else {
    //     this.$set(this.formDataBak, "baseMethodList", []);
    //   }

    // },
    getFormData(id) {
      this.loading = true;
      this.$http({
        type: "GET",
        url: "/buz/baseMethod/queryByOrgId",
        data: {
          orgId: id
        }
      }).then(res => {
        this.$set(this.formDataBak, "baseMethodList", res.data);
      }).finally(res => {
        this.loading = false;
      });
    },
    save() {
      let flag = true;
      const list = this.formDataBak.baseMethodList.map(item => {
        const startTime = this.$units.formatDate(item.startTime) + ' 00:00:00';
        const endTime = this.$units.formatDate(item.endTime) + ' 23:59:59';
        if (!dayjs(item.startTime).isBefore(item.endTime) && !(item.endTime && item.endTime.valueOf() < Date.now())) {
          flag = false
        }
        return {
          id: item.id,
          name: item.name,
          endTime: endTime,
          startTime: startTime,
        }
      })
      if (!flag) {
        this.$notice.error("基本法开始时间不能大于结束时间")
        return;
      }
      const params = {
        orgId: this.formData.id,
        baseMethodList: list
      }
      this.$http({
        type: "POST",
        url: "/buz/organizationBase/saveBaseMethod",
        data: params
      }).then(res => {
        this.disabled = true;
        this.$notice.success("保存成功");
        this.getFormData(this.formData.id)
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.salesman-form-promotion {
  .btn-wrap {
    position: absolute;
    right: 0;
    top: 2px;
    display: flex;
  }

  .add-btn {
    border: 1px solid #236DFF;
    width: 80px;
    height: 30px;
    border-radius: 2px;
    font-size: 12px;
    color: #236DFF;
    padding: 0;
    margin-right: 20px;
  }

  .link {
    color: #236DFF;
    padding: 0 2px;
    text-decoration: underline;
    cursor: pointer;

  }

  .ivu-radio-wrapper {
    font-size: 12px;
  }

  .page-form {
    margin-top: 20px;
  }

  .promotion-item {
    padding-bottom: 20px;
  }

  ul.rankList {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -10px;

    li {
      line-height: 30px;
      height: 30px;
      padding: 0 10px;
      min-width: 90px;
      background: #F5F7F9;
      color: #515C6F;
      margin-right: 10px;
      margin-bottom: 10px;
      white-space: nowrap;
      border-radius: 2px;
      font-size: 12px;
      text-align: center;
    }
  }

  .empty-box {
    text-align: center;
    padding-top: 80px;

    img {
      width: 250px;
    }

    .text {
      color: #A8ADB7;
      font-size: 12px;
      transform: translateY(-35px);
    }
  }
}
</style>